(function () {
  function slugify(str) {
    return String(str)
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function populate(select, values) {
    select.innerHTML = "";
    values.forEach(function (v) {
      var opt = document.createElement("option");
      opt.value = v;
      opt.textContent = v;
      select.appendChild(opt);
    });
  }

  function initVehicleSelector(root) {
    // The hero and the selector section both load this script; guard so
    // a root is only wired once no matter how many copies execute.
    if (root.dataset.vsInit) return;
    root.dataset.vsInit = "1";
    var dataUrl = root.dataset.fitmentUrl;
    var makeSelect = root.querySelector('[data-field="make"]');
    var modelSelect = root.querySelector('[data-field="model"]');
    var yearSelect = root.querySelector('[data-field="year"]');
    var form = root.querySelector("form");
    if (!makeSelect || !modelSelect || !yearSelect || !form) return;

    fetch(dataUrl)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        window.__vsRoutes = data.routes || null;
        populate(yearSelect, data.years);
        populate(makeSelect, Object.keys(data.makes));
        populate(modelSelect, data.makes[makeSelect.value] || []);

        makeSelect.addEventListener("change", function () {
          populate(modelSelect, data.makes[makeSelect.value] || []);
        });
      })
      .catch(function () {
        // Message lives in data-msg, not the HTML, so crawlers that read
        // the static DOM never see error copy on a working page.
        var err = root.querySelector("[data-error]");
        if (err) {
          err.textContent = err.getAttribute("data-msg") || "Couldn't load the vehicle list — refresh and try again.";
          err.removeAttribute("hidden");
        }
      });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var make = makeSelect.value;
      var model = modelSelect.value;
      if (!make || !model) return;
      var slug = slugify(make + "-" + model);
      // Generation routing: same model name, different kits per year
      // (e.g. HiLux 2026+ is the N90). Routes come from the fitment data.
      if (window.__vsRoutes && window.__vsRoutes[slug]) {
        var yr = parseInt(yearSelect.value, 10) || 0;
        var routes = window.__vsRoutes[slug];
        for (var ri = 0; ri < routes.length; ri++) {
          if (yr >= routes[ri].minYear) { slug = routes[ri].slug; break; }
        }
      }

      // Prefer the real per-vehicle collection (/collections/<make>-<model>):
      // unlike the tag-filtered view, it is indexable - Shopify canonicalises
      // /collections/all/<tag> back to /collections/all, so only the real
      // collection can rank for "<vehicle> PPF" searches, and landing there
      // keeps the journey on the SEO page Google sees.
      //
      // Probed first rather than assumed, because collections are created by
      // hand in admin and may not exist yet for every vehicle - a missing one
      // used to 404. The tag filter resolves against product tags alone, so
      // it always works as the fallback.
      fetch("/collections/" + slug, { method: "HEAD" })
        .then(function (r) {
          window.location.href = r.ok
            ? "/collections/" + slug
            : "/collections/all/" + slug;
        })
        .catch(function () {
          window.location.href = "/collections/all/" + slug;
        });
    });
  }

  document.querySelectorAll("[data-vehicle-selector]").forEach(initVehicleSelector);
})();
